import { ReactComponent as FocusedQuick } from '@assets/icons/focused_quick.svg';
import { ReactComponent as Quick } from '@assets/icons/quick.svg';
import Dot from '@components/Dot';
import { Green } from '@constants/color';
import { useDoctorSelectionContext } from '@context/DoctorSelection';
import { FocusHandler, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC } from 'react';

import { DOCTOR_SELECTION_QUICK } from '../../focusKey';

import * as styles from './styles';

interface QuickMatchingProps {
  onFocus: FocusHandler;
}

const QuickMatching: FC<QuickMatchingProps> = ({ onFocus }) => {
  const { clearDoctorSelection, goPatient } = useDoctorSelectionContext();
  const { ref, focused } = useFocusable({
    focusKey: DOCTOR_SELECTION_QUICK,
    onEnterPress: () => {
      clearDoctorSelection();
      goPatient();
    },
    onFocus
  });
  return (
    <div ref={ref} css={styles.container}>
      <div css={[styles.mainContainer, focused && styles.mainContainerFocused]}>
        <div css={styles.mainContentContainer}>
          {focused ? <FocusedQuick /> : <Quick />}
        </div>
        <div css={[styles.matching, focused && styles.matchingFocused]}>
          빠른 매칭 진료 신청
        </div>
      </div>
      <div css={styles.bottomContainer}>
        <Dot color={Green.Green80} />
        <div css={[styles.description, focused && styles.descriptionFocused]}>
          의사와 자동 매칭됩니다.
        </div>
      </div>
    </div>
  );
};

export default QuickMatching;
